import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Statut d'une appartenance à une équipe (enum App\Entity\TeamMemberStatus de l'API, GET /team_member_statuses) : Actif, Inactif */
export default class TeamMemberStatusModel extends AbstractApiModel {
  protected _path = '/team_member_statuses/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:team_member_status:${this.id}`);
  }
}
